import AutorenewIcon from "@mui/icons-material/Autorenew";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { Chip, Stack } from "@mui/material";
import { E2eTestRunResult } from "services/KnowfullyAdminClient";

type StatChipProps = {
  icon: React.ReactElement;
  label: string;
  color: "success" | "error" | "warning" | "default";
};

const StatChip = ({ icon, label, color }: StatChipProps) => (
  <Chip
    size="small"
    icon={icon}
    label={label}
    color={color === "default" ? undefined : color}
    variant="outlined"
  />
);

type RunStatsSummaryProps = {
  run: E2eTestRunResult;
};

const RunStatsSummary = ({ run }: RunStatsSummaryProps) => {
  if (run.passedTests == null && run.failedTests == null) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap">
      {run.passedTests != null && (
        <StatChip icon={<CheckCircleOutlineIcon />} label={`${run.passedTests} passed`} color="success" />
      )}
      {!!run.failedTests && (
        <StatChip icon={<ErrorOutlineIcon />} label={`${run.failedTests} failed`} color="error" />
      )}
      {!!run.flakyTests && (
        <StatChip icon={<AutorenewIcon />} label={`${run.flakyTests} flaky`} color="warning" />
      )}
      {!!run.skippedTests && (
        <StatChip icon={<RemoveCircleOutlineIcon />} label={`${run.skippedTests} skipped`} color="default" />
      )}
    </Stack>
  );
};

export default RunStatsSummary;
